import { useEffect, useState } from "react";
import {
  ensureReactXarrowsScriptIsLoaded,
  ReactXarrowsWrapperType,
} from "../utils/reactXarrowsSingeltonInstance";
import { serializeErrorForTracking, track } from "../utils/tracking";

export default function useReactXarrows() {
  const [showArrows, setShowArrows] = useState(false);
  const [ReactXarrowsWrapper, setReactXarrowsWrapper] =
    useState<ReactXarrowsWrapperType | null>(null);

  useEffect(() => {
    loadReactXarrows();
  }, []);

  useEffect(() => {
    if (ReactXarrowsWrapper) {
      const timer = setTimeout(() => {
        setShowArrows(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [ReactXarrowsWrapper]);

  const loadReactXarrows = async () => {
    try {
      await ensureReactXarrowsScriptIsLoaded();
      setReactXarrowsWrapper(
        window?.ReactXarrowsWrapper as ReactXarrowsWrapperType
      );
    } catch (error) {
      console.error("Failed to load ReactXarrows:", error);
      track("ERROR", {
        on: "loadReactXarrows",
        what: serializeErrorForTracking(error as Error),
      });
    }
  };

  return { showArrows, ReactXarrowsWrapper };
}
